import {INeighbourhood} from "../../api/Model";
import {NeighbourhoodGuess} from "./GuessNeighbourhoods";
import {SubtreeSize} from "../../util/EmployeeHierarchy";
import {Grid, Paper, Radio, Stack, Typography} from "@mui/material";
import NeighbourhoodColorIcon from "../neighbourhood-icon/NeighbourhoodColorIcon";
import {NeighbourhoodMatchScoreChip} from "./NeighbourhoodMatchScoreChip";
import {TeamGuessPane} from "./TeamGuessPane";
import React, {useCallback} from "react";
import {SetState} from "../../util/FormHandlers";

export type SelectedNeighbourhood = [INeighbourhood | undefined, SetState<INeighbourhood | undefined>];

export function NeighbourhoodGuessPane({guess, globalTeamSize, localTeamSize, selectedNeighbourhood}: {
    guess: NeighbourhoodGuess,
    globalTeamSize: SubtreeSize,
    localTeamSize: SubtreeSize,
    selectedNeighbourhood?: SelectedNeighbourhood,
}) {
    const handleSelect = useCallback(
        () => {
            if (selectedNeighbourhood) {
                const [, setSelectedNeighbourhood] = selectedNeighbourhood;
                setSelectedNeighbourhood(guess.neighbourhood);
            }
        },
        [selectedNeighbourhood, guess.neighbourhood]
    );

    const isSelected = selectedNeighbourhood?.[0]?.id === guess.neighbourhood.id;

    return (
        <Paper onClick={handleSelect} sx={{
            p: 2,
            ...(selectedNeighbourhood ? {
                cursor: 'pointer',
                backgroundColor: isSelected ? 'action.selected' : undefined,
                ":hover": theme => ({
                    backgroundColor: theme.palette.action.hover,
                }),
            } : {})
        }}>
            <Stack spacing={2}>
                <Grid container flexDirection="row" spacing={0} alignItems="center">
                    <Grid>
                        {selectedNeighbourhood && (
                            <Radio checked={isSelected} onClick={handleSelect} sx={{m: 0}}/>
                        )}
                    </Grid>
                    <Grid container size="grow" alignItems="center" spacing={2}>
                        <NeighbourhoodColorIcon neighbourhood={guess.neighbourhood}/>
                        <Typography variant="subtitle1">
                            {guess.neighbourhood.name}
                        </Typography>
                    </Grid>
                    <Grid alignItems="center" flexDirection="row" spacing={1} container>
                        <NeighbourhoodMatchScoreChip score={guess.weight} type="global"/>
                        <NeighbourhoodMatchScoreChip score={guess.localWeight} type="local"/>
                    </Grid>
                </Grid>

                {guess.teams.map(team => (
                    <TeamGuessPane
                        key={team.commonManager.id}
                        team={team}
                        globalTeamSize={globalTeamSize.getSize(team.commonManager)}
                        localTeamSize={localTeamSize.getSize(team.commonManager)}
                    />
                ))}
            </Stack>
        </Paper>);
}